import { render, staticRenderFns } from "./SidebarFilterBadgesContainer.vue?vue&type=template&id=e75744e2&scoped=true&"
import script from "./SidebarFilterBadgesContainer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SidebarFilterBadgesContainer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SidebarFilterBadgesContainer.vue?vue&type=style&index=0&id=e75744e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75744e2",
  null
  
)

export default component.exports